'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BELMETERUG_URL: '/_vti_bin/Achmea.Sharepoint.WebApiProxy/Proxy.svc/Achmea.KCC.Communication.OpslaanBelMeTerugVerzoek'
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/service-assistent/service-assistent.constants.js
// module id = 902
// module chunks = 0